import React from "react";
import axios from "axios";

export const countryApiId = async (id) => {
  try {
    let url = `https://visapro-api.tcore.online/api/v1/countries/${id}`;

    const response = await axios.get(url);
    const country = {
      data: response.data,
    };
    return country;
  } catch (error) {
    const country = {
      error: error,
    };
    return country;
  }
};
